import { ConfigProvider } from '@ecdlink/core';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import React from 'react';
import ReactDOM from 'react-dom';
import ConfigWrapper from './config-wrapper';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles.css';

if (
  process.env.NODE_ENV === 'development' &&
  process.env?.REACT_APP_RUN_MOCKS === 'run_msw'
) {
  const { worker } = require('./mocks/browser');
  worker.start();
}

ReactDOM.render(
  <ConfigProvider
    config={{
      authApi: process.env.REACT_APP_API || '',
      graphQlApi: process.env.REACT_APP_GRAPHQLAPI || '',
      themeUrl: process.env.REACT_APP_THEME || '',
    }}
  >
    <ConfigWrapper />
  </ConfigProvider>,
  document.getElementById('root')
);

serviceWorkerRegistration.register();

defineCustomElements(window);
reportWebVitals();
